import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from "../../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import useGetInfoSolicitudGastosTransporte from "services/record/SolicitudGastosTransporte/useGetInfoSolicitudGastosTransporte";
import SolicitudGastosTransporte from "./SolicitudGastosTransporte";

const GridSolicitudGastosTransporte = ({ expedienteId = null, origen = null }) => {
    const {
        getInfoSolicitudGastosTransporte,
        loadingGetInfoSolicitudGastosTransporte,
        statusGetInfoSolicitudGastosTransporte
    } = useGetInfoSolicitudGastosTransporte();

    const [dataUser, setDataUser] = useState<Record<string, unknown> | null>(null);
    const getInfoRef = useRef(getInfoSolicitudGastosTransporte);

    const title = "Solicitud de Gastos de Transporte";
    const navigate = useNavigate();
    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    useEffect(() => {
        getInfoRef.current = getInfoSolicitudGastosTransporte;
    }, [getInfoSolicitudGastosTransporte]);

    useEffect(() => {
        let active = true;
        setDataUser(null);
        if (userId) {
            getInfoRef.current(userId, expedienteIdByOrigen, data => {
                if (active) {
                    setDataUser(expedienteIdByOrigen !== null
                        ? { ...data, ExpedienteIdByOrigen: expedienteIdByOrigen }
                        : data);
                }
            }).catch(() => undefined);
        }
        return () => { active = false; };
    }, [userId, expedienteIdByOrigen]);

    const currentHttp = statusGetInfoSolicitudGastosTransporte;

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <Loader activeLoader={loadingGetInfoSolicitudGastosTransporte} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <SolicitudGastosTransporte
                        dataUser={dataUser}
                        info={true}
                    />
                </div>
            )}

            {currentHttp.status && !loadingGetInfoSolicitudGastosTransporte && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridSolicitudGastosTransporte;
